import React from 'react'
import { TestTakerName, XSSpaceBetween } from 'styles/GlobalStyle'
import { Chip } from 'components/Form'
import { WrapAssessmentDetails } from './Style'
import { useTheme } from 'styles'
import { useSelector } from 'react-redux'
import { thirdly } from 'styles/theme'
import { keyBy } from 'lodash'
import { semesters } from 'keys'
import { getSemester } from 'utils/general'

const AssessmentDetails = () => {
    const { Layout } = useTheme()

    const { brokenDisplay } = useSelector(state => state.general)
    const { assessment } = useSelector(state => state.assessment)
    const { testTaker } = useSelector(state => state.testTaker)

    const currentSemester = getSemester(assessment.create_date)
    const semestersKeys = keyBy(semesters, "id")
    const semester = semestersKeys?.[currentSemester]

    return (
        <WrapAssessmentDetails>
            <div style={{ ...Layout.fullWidth, ...Layout.colHCenter, ...Layout.mrGap }}>
                <div style={{ ...Layout.flex }}>
                    {testTaker?.test_taker_name &&
                        <React.Fragment>
                            <TestTakerName className={`${brokenDisplay && 'blurred2'}`}>
                                {testTaker?.test_taker_name}
                            </TestTakerName>
                            <XSSpaceBetween />
                            <div style={{ ...Layout.flex }}>
                                {assessment.learning_unit_affiliation_name && <Chip transparent color={thirdly}>{assessment.learning_unit_affiliation_name}</Chip>}
                                {assessment.reading_assessment_grade_of_execution_name && <Chip transparent color={thirdly}>{assessment.reading_assessment_grade_of_execution_name}</Chip>}
                                <Chip transparent color={thirdly}>{semester.name}</Chip>
                                {assessment.school_year && <Chip transparent color={thirdly}>{assessment.school_year}</Chip>}
                                {assessment.reading_assessment_category_label && <Chip transparent color={thirdly}>{assessment.reading_assessment_category_label}</Chip>}
                            </div>
                        </React.Fragment>
                    }
                </div>
            </div>
        </WrapAssessmentDetails>
    )
}

export default AssessmentDetails
